<form [formGroup]="form" (submit)="onOkClick()">
  <h1 mat-dialog-title>Modifică coordonatele lui {{data.point}}</h1>
  <div mat-dialog-content>
    <mat-form-field appearance="fill">
      <mat-label>X:</mat-label>
      <input matInput formControlName="x" type="text" name="x" pattern="^[0-9]+[,.]?[0-9]*$" required autocomplete="off"
             (change)="formDecimalInputChange($event, 'x', 0)">
      <span matSuffix>metri</span>
    </mat-form-field>
    <div class="form-warning" *ngIf="this.form?.controls?.x?.value > 100">
      {{getNotInMetersWarningText('x')}}
      <button (click)="updateToMeters('x')">Schimbă</button>
    </div>
    <mat-form-field appearance="fill">
      <mat-label>Y:</mat-label>
      <input matInput formControlName="y" type="text" name="y" pattern="^[0-9]+[,.]?[0-9]*$" required autocomplete="off"
             (change)="formDecimalInputChange($event, 'y', 0)">
      <span matSuffix>metri</span>
    </mat-form-field>
    <div class="form-warning" *ngIf="this.form?.controls?.y?.value > 100">
      {{getNotInMetersWarningText('y')}}
      <button (click)="updateToMeters('y')">Schimbă</button>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-raised-button mat-dialog-close>Înapoi</button>
    <button mat-button mat-raised-button color="primary" [disabled]="!form.valid" (click)="onOkClick()">Salvează</button>
  </div>
</form>
